import React, { useEffect, useRef, useState } from "react";
import {
  Project,
  ProjectRespData,
  ProjectRespDataInternal,
  getAllProjects,
  getProjects,
  groupProject,
} from "common/api/ApiService";
import "./index.scss";
import TableBodys from "./TableBody";
import { useLocation, useNavigate } from "react-router-dom";
import DashboardHeader from "components/DashboardHeader";
import {
  FaAngleDown,
  FaAngleUp,
  FaEdit,
  FaFilter,
  FaPlus,
  FaRegObjectUngroup,
  FaSort,
} from "react-icons/fa";
import { IoArrowBack, IoCloseCircleOutline } from "react-icons/io5";
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Chip,
  IconButton,
  MenuItem,
  Modal,
  TableBody,
  TextField,
  Tooltip,
} from "@mui/material";
import { Label } from "@mui/icons-material";
import YourComponent from "./ToolTips";
import BillingStatus from "./StatusTips";
import Progress from "./ToolTipp";
import Satisfaction from "./TeamSatisfaction";
import ToolTipComponent from "./ToolTips";

const tooltipStyles = {
  tooltip: {
    backgroundColor: "white", // Background color
    color: "#333", // Text color
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)", // Shadow
    fontSize: "10px",
  },
};

export const departmentOptions = [
  { label: "Clear", value: 0 },
  { label: "Design", value: 1 },
  { label: "Development", value: 2 },
  { label: "Multi", value: 3 },
];

const criticalityOptions = [
  { label: "Clear", value: 0 },
  { label: "Platinum", value: "Platinum" },
  { label: "Diamond", value: "Diamond" },
  { label: "Premium", value: "Premium" },
];

const projectStatusOptions = [
  { label: "Clear", value: 0 },
  { label: "Not started", value: 1 },
  { label: "In progress", value: 2 },
  { label: "Hold", value: 3 },
  { label: "Closed", value: 4 },
];
const projectTypeOptions = [
  { label: "Clear", value: 0 },
  { label: "T&M", value: 1 },
  { label: "Fixed", value: 2 },
  { label: "T&M(Cap)", value: 3 },
  { label: "Retainer", value: 4 },
];
interface Props {
  selectedProjectId: string;
  setSelectedProjectId: (projectId: string) => void;
  isEdit: boolean;
  setIsEdit: (isEdit: boolean) => void;
  isSuccessEdit: boolean;
  setIsSuccessEdit: (isSuccessEdit: boolean) => void;
}

const InternalDashboardTable: React.FC<Props> = ({
  selectedProjectId,
  setSelectedProjectId,
  isEdit,
  setIsEdit,
  isSuccessEdit,
  setIsSuccessEdit,
}) => {
  const [isLogged, setIsLogged] = useState<boolean>(false);
  const token = sessionStorage.getItem("authToken");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [groupName, setGroupName] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedSubProject, setSelectedSubProject] = useState<Project[]>([]);
  const [dropdownProjects, setDropdownProjects] = useState<Project[]>([]);
  const [projects, setProjects] = useState<ProjectRespDataInternal[]>([]);
  const [selectedFilter, setSelectedFilter] = useState<FilterType | null>(null);
  const [expandedProjectId, setExpandedProjectId] = useState<number | null>(
    null
  );
  const [filterProjects, setFilterProjects] = useState<
    ProjectRespDataInternal[]
  >([]);
  const [selectedCriticality, setSelectedCriticality] = useState<string | null>(
    null
  );

  const [selectedDepartment, setSelectedDepartment] = useState<number | null>(
    null
  );

  const [selectedStatus, setSelectedStatus] = useState<number | null>(null);
  const [activeFilters, setActiveFilters] = useState<boolean | null>(false);
  // const [activeSort,setActiveSort]=useState(false)
  const [plannedEbitdaFilter, setPlannedEbitdaFilter] = useState<number[]>([]);
  const [actualEbitdaFilter, setActualEbitdaFilter] = useState<number[]>([]);
  const [targetEbitdaFilter, setTargetEbitdaFilter] = useState<number[]>([]);
  const [plannedRevenueFilter, setPlannedRevenueFilter] = useState<
    number | null
  >(null);

  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState<"success" | "error">("success");
  const [alertMessage, setAlertMessage] = useState("");
  const [selectedProjectType, setSelectedProjectType] = useState<number | null>(
    null
  );
  const navigate = useNavigate();
  const containerRef = useRef(null);
  const [filterVisible, setFilterVisible] = useState(false);

  const filterRefs = Array.from({ length: 10 }, () =>
    useRef<HTMLDivElement | null>(null)
  );

  const [appliedFilters, setAppliedFilters] = useState<{
    [key in FilterType]?: boolean;
  }>({});
  useEffect(() => {
    if (token) {
      setIsLogged(true);
    } else {
      setIsLogged(false);
    }
  }, [token]);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        setLoading(true);
        const data = await getProjects();
        setProjects(data);
        setFilterProjects(data);
        // console.log(filterProjects);
        // console.log(data);
      } catch (error) {
        showAlertMessage("error", "Error while fetching projects");
        console.error("Error fetching projects:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  useEffect(() => {
    const fetchProjectList = async () => {
      try {
        // setLoading(true);
        const data = await getAllProjects(1, [1, 2],0);
        setDropdownProjects(data);
      } catch (error) {
        showAlertMessage("error", "Error while fetching project data");
        console.error("Error while fetching project data", error);
      }
    };
    fetchProjectList();
  }, []);

  useEffect(() => {
    if (isSuccessEdit || isEdit) {
      const fetchProjects = async () => {
        try {
          setLoading(true);
          const data = await getProjects();
          setProjects(data);
          // console.log("updated", data);
          setIsEdit(false);
          setIsSuccessEdit(false);
        } catch (error) {
          showAlertMessage("error", "Error while fetching projects");
          console.error("Error fetching projects:", error);
        } finally {
          setLoading(false);
        }
      };

      fetchProjects();
    }
  }, [isSuccessEdit, isEdit]);

  const handleFilterClick = () => {
    setFilterVisible(!filterVisible);
  };
  const handleClickOutside = (event: MouseEvent) => {
    if (
      filterRefs.every(
        (ref) => ref.current && !ref.current.contains(event.target as Node)
      )
    ) {
      setSelectedFilter(null);
      toggleFilter("null");
      setFilterVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  type FilterType =
    | "Criticality"
    | "Department"
    | "Status"
    | "ProjectType"
    | "PlannedEBITDA"
    | "ActualEBITDA"
    | "TargetEBITDA"
    | "PlannedRevenue";

  interface FilterVisibility {
    Criticality: boolean;
    Department: boolean;
    Status: boolean;
    ProjectType: boolean;
    PlannedEBITDA: boolean;
    ActualEBITDA: boolean;
    TargetEBITDA: boolean;
    PlannedRevenue: boolean;
  }

  const [filterVisibility, setFilterVisibility] = useState<FilterVisibility>({
    Criticality: false,
    Department: false,
    Status: false,
    ProjectType: false,
    PlannedEBITDA: false,
    ActualEBITDA: false,
    TargetEBITDA: false,
    PlannedRevenue: false,
  });

  const handleFilterChange = (selectedOption: FilterType) => {
    if (selectedFilter === selectedOption) {
      setSelectedFilter(null);
      toggleFilter("null");
    } else {
      setSelectedFilter(selectedOption);

      toggleFilter(selectedOption);
    }
  };

  const toggleFilter = (filterType: FilterType | "null") => {
    // console.log(filterType);
    setFilterVisibility((prevState) => ({
      Criticality: false,
      Department: false,
      ProjectType: false,
      Status: false,
      PlannedEBITDA: false,
      ActualEBITDA: false,
      TargetEBITDA: false,
      PlannedRevenue: false,
      [filterType]:
        filterType !== "null" && !prevState[filterType as FilterType],
    }));
  };
  const handleFilterValueChange = (filterType: FilterType, value: any) => {
    let updatedCriticality = selectedCriticality;
    let updatedDepartment = selectedDepartment;
    let updatedStatus = selectedStatus;
    let updatedProjectType = selectedProjectType;
    let updatedPlannedEbitdaFilter = [...plannedEbitdaFilter];
    let updatedActualEbitdaFilter = [...actualEbitdaFilter];
    let updatedTargetEbitdaFilter = [...targetEbitdaFilter];
    let updatedPlannedRevenueFilter = plannedRevenueFilter;

    // console.log(`Filter type: ${filterType}, Value:`, value);

    switch (filterType) {
      case "Criticality":
        updatedCriticality = value === 0 ? null : value;
        setSelectedCriticality(updatedCriticality);
        handleFilterChange("Criticality");
        break;
      case "ProjectType":
        updatedProjectType = value === 0 ? null : value;
        setSelectedProjectType(updatedProjectType);
        handleFilterChange("ProjectType");
        break;
      case "Department":
        updatedDepartment = value === 0 ? null : value;
        setSelectedDepartment(updatedDepartment);
        handleFilterChange("Department");
        break;
      case "Status":
        updatedStatus = value === 0 ? null : value;
        setSelectedStatus(updatedStatus);
        handleFilterChange("Status");
        break;
      case "PlannedEBITDA":
        updatedPlannedEbitdaFilter =
          value === 0
            ? []
            : toggleValueInArray(updatedPlannedEbitdaFilter, value);
        setPlannedEbitdaFilter(updatedPlannedEbitdaFilter);
        break;
      case "ActualEBITDA":
        updatedActualEbitdaFilter =
          value === 0
            ? []
            : toggleValueInArray(updatedActualEbitdaFilter, value);
        setActualEbitdaFilter(updatedActualEbitdaFilter);
        break;
      case "TargetEBITDA":
        updatedTargetEbitdaFilter =
          value === 0
            ? []
            : toggleValueInArray(updatedTargetEbitdaFilter, value);
        setTargetEbitdaFilter(updatedTargetEbitdaFilter);
        break;
      case "PlannedRevenue":
        updatedPlannedRevenueFilter =
          value === 0 ? null : isNaN(value) ? null : value;
        setPlannedRevenueFilter(updatedPlannedRevenueFilter);
        handleFilterChange("PlannedRevenue");
        break;
      default:
        break;
    }
    setAppliedFilters((prevFilters) => ({
      ...prevFilters,
      [filterType]: value !== 0,
    }));

    // Use updatedCriticality directly in the filter logic
    const filtered = projects?.filter((project) => {
      if (updatedCriticality && project.criticality !== updatedCriticality) {
        return false;
      }
      if (updatedDepartment && project.departmentId !== updatedDepartment) {
        return false;
      }
      if (updatedProjectType && project.projectType.id !== updatedProjectType) {
        return false;
      }
      if (updatedStatus && project.projectStatusId !== updatedStatus) {
        return false;
      }
      if (
        updatedPlannedEbitdaFilter.length > 0 &&
        !updatedPlannedEbitdaFilter.includes(project.plannedEbitda)
      ) {
        return false;
      }
      if (
        updatedPlannedRevenueFilter !== null &&
        project.totalQuote !== updatedPlannedRevenueFilter
      ) {
        return false;
      }
      if (
        updatedActualEbitdaFilter.length > 0 &&
        !updatedActualEbitdaFilter.includes(project.actualEbitda)
      ) {
        return false;
      }
      if (
        updatedTargetEbitdaFilter.length > 0 &&
        !updatedTargetEbitdaFilter.includes(project.targetEbitda)
      ) {
        return false;
      }
      return true;
    });

    // console.log("Filtered projects:", filtered);

    setFilterProjects(filtered);
    setActiveFilters(true);
    // resetOtherFilters(filterType);
  };
  const toggleValueInArray = (array: any[], value: any) => {
    return array.includes(value)
      ? array.filter((v) => v !== value)
      : [...array, value];
  };

  // this function helps in ediitng that particular project
  const handleEditClick = (projectId: string) => {
    setSelectedProjectId(projectId);
    setIsEdit(true);
    navigate("/project-iq/createform");
  };

  // this function helps us to expand the subproject if there on clicking project name
  const handleProjectNameClick = (projectId: number) => {
    setExpandedProjectId(expandedProjectId === projectId ? null : projectId);
  };

  // this helps in getting TL, DM, PM , PO names
  useEffect(() => {
    if (isSuccessEdit || isEdit) {
      const fetchProjects = async () => {
        try {
          const data = await getProjects();
          setProjects(data);
          setIsEdit(false);
          setIsSuccessEdit(false);
        } catch (error) {
          console.error("Error fetching projects:", error);
        }
      };

      fetchProjects();
    }
  }, [isSuccessEdit, isEdit]);

  const handleCreateForm = () => {
    setIsEdit(false);
    setSelectedProjectId("0");
    navigate("/project-iq/createform");
  };

  const [sortDirectionPlannedRevenue, setSortDirectionPlannedRevenue] =
    useState<"ascending" | "descending" | "none">("ascending");
  const [sortDirectionPlannedEBITDA, setSortDirectionPlannedEBITDA] = useState<
    "ascending" | "descending" | "none"
  >("ascending");
  const [sortDirectionTargetEBITDA, setSortDirectionTargetEBITDA] = useState<
    "ascending" | "descending" | "none"
  >("ascending");
  const [sortDirectionActualEBITDA, setSortDirectionActualEBITDA] = useState<
    "ascending" | "descending" | "none"
  >("ascending");

  // Function to toggle sort direction for the general sort

  // Function to handle sorting by a specified field

  const handleScroll = () => {
    setSelectedFilter(null);
    toggleFilter("null");
  };

  const handleSave = async () => {
    // console.log(groupName);
    const savedProjects = selectedSubProject.map((project) => ({
      projectId: project.project_id,
    }));

    const payload: any = {
      name: groupName,
      subProjects: savedProjects,
    };
    try {
      if (!groupName) {
        showAlertMessage("error", "Required Project Name");
        return;
      }
      if (savedProjects.length < 2) {
        showAlertMessage("error", "Required Min 2 Projects to Create Group");
        return;
      }
      // console.log(JSON.stringify(payload));
      const resp = await groupProject(payload);
      // const resp = true;
      if (resp) {
        showAlertMessage("success", "Grouped Project Successfully");
        setIsSuccessEdit(true);
        setTimeout(() => {
          handleCancel();
          setIsModalOpen(false);
        }, 2000);
      } else showAlertMessage("error", "Error While Grouping Project");
      // console.log("response", resp);
    } catch (error) {
      console.error("error while creating sub projects");
    }
  };
  const watchActiveFilters = Object.values(appliedFilters).some(
    (filter) => filter === true
  );
  const handleCancel = () => {
    setIsModalOpen(false);
    setGroupName("");
    setSelectedSubProject([]);
  };

  const clearAllFilters = () => {
    setSelectedCriticality(null);
    setSelectedDepartment(null);
    setSelectedStatus(null);
    setSelectedProjectType(null);
    setPlannedEbitdaFilter([]);
    setActualEbitdaFilter([]);
    setTargetEbitdaFilter([]);
    setPlannedRevenueFilter(null);
    setAppliedFilters({});
    setFilterProjects(projects); // Reset to show all projects
    setActiveFilters(false);
  };

  const handleSort = (
    field: keyof ProjectRespDataInternal,
    columnSortDirection: "ascending" | "descending" | "none",
    setColumnSortDirection: React.Dispatch<
      React.SetStateAction<"ascending" | "descending" | "none">
    >
  ) => {
    // Toggle sort direction for the current column
    setSelectedFilter(null);
    if (field == "actualEbitda") {
      setSortDirectionPlannedEBITDA("ascending");
      setSortDirectionTargetEBITDA("ascending");
    } else if (field == "targetEbitda") {
      setSortDirectionPlannedEBITDA("ascending");
      setSortDirectionActualEBITDA("ascending");
    } else if (selectedFilter !== null) {
      setSortDirectionPlannedEBITDA("ascending");
      setSortDirectionTargetEBITDA("ascending");
      setSortDirectionActualEBITDA("ascending");
    } else {
      setSortDirectionTargetEBITDA("ascending");
      setSortDirectionActualEBITDA("ascending");
    }

    const toggleSortDirection = () => {
      setColumnSortDirection((currentDirection) => {
        if (currentDirection === "none") {
          return "ascending";
        } else if (currentDirection === "ascending") {
          return "descending";
        } else {
          return "none";
        }
      });
    };

    // Toggle sort direction when handling sort
    toggleSortDirection();
    // console.log("here");
    // Sorting logic based on the current column's sort direction
    const sortedProjects = [...filterProjects].sort((a, b) => {
      // Ensure values are converted to numbers if they are strings
      const aValue =
        typeof a[field] === "string"
          ? parseFloat(a[field] as string)
          : (a[field] as number) || 0;
      const bValue =
        typeof b[field] === "string"
          ? parseFloat(b[field] as string)
          : (b[field] as number) || 0;

      if (columnSortDirection === "ascending") {
        return aValue - bValue;
      } else if (columnSortDirection === "descending") {
        return bValue - aValue;
      }
      window.location.reload();
      return 0; // No sorting
    });
    // console.log(sortedProjects);

    // Update state with sorted projects
    setFilterProjects(sortedProjects);

    // console.log(filterProjects);
  };
  const showAlertMessage = (type: "success" | "error", message: string) => {
    setAlertType(type);
    setAlertMessage(message);
    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
      setAlertMessage("");
      // setAlertType("");
    }, 2000);
  };

  return (
    <>
      {loading && (
        <div className="loader-overlay">
          <div className="loader"></div>
        </div>
      )}
      <DashboardHeader />
      {isLogged && (
        <div>
          <div className="header-container">
            <span onClick={() => navigate("/")} className="back-icon-dashboard">
              <IoArrowBack size={24} />
            </span>

            <h1>Internal Dashboard</h1>

            <Tooltip title="Create Project">
              <button onClick={handleCreateForm}>
                <FaPlus />
              </button>
            </Tooltip>

            <Tooltip title="Group Projects">
              <button
                onClick={() => {
                  setIsEdit(true);
                  setIsModalOpen(true);
                  setShowAlert(false);
                }}
              >
                <FaRegObjectUngroup />
              </button>
            </Tooltip>

            <Modal open={isModalOpen} onClose={handleCancel}>
              <Box className="modal-box">
                {showAlert && (
                  <Alert
                    severity={alertType}
                    className="floating-alert"
                    action={
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={() => setShowAlert(false)}
                      >
                        <IoCloseCircleOutline fontSize="inherit" />
                      </IconButton>
                    }
                  >
                    {alertMessage}
                  </Alert>
                )}
                <h2>Group Projects</h2>
                <TextField
                  label="Project Name"
                  value={groupName}
                  onChange={(e) => setGroupName(e.target.value)}
                  fullWidth
                  margin="normal"
                />
                <Autocomplete
                  multiple
                  options={dropdownProjects}
                  getOptionLabel={(option) => option.name}
                  value={selectedSubProject}
                  onChange={(event, newValue) => {
                    setSelectedSubProject(newValue as Project[]);
                  }}
                  renderTags={(tagValue, getTagProps) => {
                    if (containerRef.current) {
                      (containerRef.current as HTMLDivElement).scrollTop = (
                        containerRef.current as HTMLDivElement
                      ).scrollHeight;
                    }

                    return (
                      <div
                        ref={containerRef}
                        style={{
                          maxHeight: "7em",
                          overflowY: "auto",
                          maxWidth: "100%",
                        }}
                      >
                        {tagValue.map((option, index) => (
                          <Chip
                            label={option.name}
                            {...getTagProps({ index })}
                            key={`${option.project_id}-${index}`}
                          />
                        ))}
                      </div>
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Projects"
                      fullWidth
                      margin="normal"
                      // multiline={true}
                      rows={3}
                    />
                  )}
                />

                <Box
                  display="flex"
                  justifyContent="flex-end"
                  // marginTop="20px"
                  position="fixed"
                  bottom="30px"
                  width="90%"
                  padding="10px"
                >
                  <Button
                    onClick={handleCancel}
                    variant="contained"
                    style={{ marginRight: "10px" }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={handleSave}
                    variant="contained"
                    color="primary"
                  >
                    Save
                  </Button>
                </Box>
              </Box>
            </Modal>
          </div>
          <div className="table-container">
            <div className="table-wrapper" onScroll={handleScroll}>
              <table>
                {/* table headers */}
                <thead>
                  <tr>
                    <th className="maxi fixed ">Name</th>
                    <th className="maxi" style={{ position: "relative" }}>
                      Project Type
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => handleFilterChange("ProjectType")}
                        className={
                          appliedFilters.ProjectType ? "active-filter" : ""
                        }
                        ref={filterRefs[8]}
                      >
                        <FaFilter
                          style={{
                            marginLeft: "5px",
                            cursor: "pointer",
                            fontSize: "8px",
                          }}
                        />
                      </span>
                      <div ref={filterRefs[9]}>
                        {filterVisibility.ProjectType && (
                          <div className="filter-item">
                            {projectTypeOptions.map((option) => (
                              <div
                                key={option.value}
                                className={
                                  (selectedProjectType === option.value
                                    ? "selected-filter"
                                    : "") +
                                  (option.value === 0 &&
                                  selectedProjectType === null
                                    ? " disabled"
                                    : "")
                                }
                                onClick={() =>
                                  handleFilterValueChange(
                                    "ProjectType",
                                    option.value
                                  )
                                }
                              >
                                {option.label}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </th>

                    <th className="maxi" style={{ position: "relative" }}>
                      Criticality
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => handleFilterChange("Criticality")}
                        className={
                          appliedFilters.Criticality ? "active-filter" : ""
                        }
                        ref={filterRefs[1]}
                      >
                        <FaFilter
                          style={{
                            marginLeft: "5px",
                            cursor: "pointer",
                            fontSize: "8px",
                          }}
                        />
                      </span>
                      <div ref={filterRefs[3]}>
                        {filterVisibility.Criticality && (
                          <div className="filter-item">
                            {criticalityOptions.map((option) => (
                              <div
                                key={option.value}
                                className={
                                  (selectedCriticality === option.value
                                    ? "selected-filter"
                                    : "") +
                                  (option.value === 0 &&
                                  selectedCriticality === null
                                    ? " disabled"
                                    : "")
                                }
                                onClick={() =>
                                  handleFilterValueChange(
                                    "Criticality",
                                    option.value
                                  )
                                }
                              >
                                {option.label}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </th>

                    <th className="maxi" style={{ position: "relative" }}>
                      Department
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => handleFilterChange("Department")}
                        className={
                          appliedFilters.Department ? "active-filter" : ""
                        }
                        ref={filterRefs[4]}
                      >
                        <FaFilter
                          style={{
                            marginLeft: "5px",
                            cursor: "pointer",
                            fontSize: "8px",
                          }}
                        />
                      </span>
                      <div ref={filterRefs[5]}>
                        {filterVisibility.Department && (
                          <div className="filter-item">
                            {departmentOptions.map((option) => (
                              <div
                                className={
                                  (selectedDepartment === option.value
                                    ? "selected-filter"
                                    : "") +
                                  (option.value === 0 &&
                                  selectedDepartment === null
                                    ? " disabled"
                                    : "")
                                }
                                key={option.value}
                                onClick={() =>
                                  handleFilterValueChange(
                                    "Department",
                                    option.value
                                  )
                                }
                              >
                                {option.label}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </th>

                    <th className="maxi" style={{ position: "relative" }}>
                      <Tooltip
                        title={<Progress />}
                        componentsProps={{
                          tooltip: {
                            sx: tooltipStyles.tooltip,
                          },
                        }}
                      >
                        <span>Project Status</span>
                      </Tooltip>

                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => handleFilterChange("Status")}
                        className={appliedFilters.Status ? "active-filter" : ""}
                        ref={filterRefs[2]}
                      >
                        <FaFilter
                          style={{
                            marginLeft: "5px",
                            cursor: "pointer",
                            fontSize: "8px",
                          }}
                        />
                      </span>
                      <div ref={filterRefs[0]}>
                        {filterVisibility.Status && (
                          <div className="filter-item">
                            {projectStatusOptions.map((option) => (
                              <div
                                key={option.value}
                                className={
                                  (selectedStatus === option.value
                                    ? "selected-filter"
                                    : "") +
                                  (option.value === 0 && selectedStatus === null
                                    ? " disabled"
                                    : "")
                                }
                                onClick={() =>
                                  handleFilterValueChange(
                                    "Status",
                                    option.value
                                  )
                                }
                              >
                                {option.label}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </th>

                    <th
                      className="maxi-header"
                      style={{ position: "relative" }}
                    >
                      Planned Revenue (₹)
                      <span
                        onClick={() => handleFilterChange("PlannedRevenue")}
                        className={
                          appliedFilters.PlannedRevenue ? "active-filter" : ""
                        }
                        style={{ cursor: "pointer" }}
                        ref={filterRefs[6]}
                      >
                        <FaFilter
                          style={{
                            marginLeft: "5px",
                            cursor: "pointer",
                            fontSize: "8px",
                          }}
                        />
                      </span>
                      <span
                        onClick={() =>
                          handleSort(
                            "totalQuote",
                            sortDirectionPlannedRevenue,
                            setSortDirectionPlannedRevenue
                          )
                        }
                        style={{ cursor: "pointer" }}
                      >
                        {sortDirectionPlannedRevenue === "ascending" && (
                          <FaAngleUp />
                        )}
                        {sortDirectionPlannedRevenue === "descending" && (
                          <FaAngleDown />
                        )}
                        {sortDirectionPlannedRevenue === "none" && (
                          <FaSort style={{ marginLeft: "5px" }} />
                        )}
                      </span>
                      <div ref={filterRefs[7]}>
                        {filterVisibility.PlannedRevenue && (
                          <div className="filter-item">
                            {[
                              { value: "All", label: "All" },
                              ...Array.from(
                                new Set(
                                  projects.map((project) => project.totalQuote)
                                )
                              ),
                            ].map((option, index) => {
                              if (typeof option === "number") {
                                return (
                                  <div
                                    key={index}
                                    onClick={() =>
                                      handleFilterValueChange(
                                        "PlannedRevenue",
                                        option
                                      )
                                    }
                                    style={{
                                      cursor: "pointer",
                                      padding: "5px 10px",
                                    }}
                                  >
                                    {option.toString()}
                                  </div>
                                );
                              } else {
                                return (
                                  <div
                                    key={index}
                                    onClick={() =>
                                      handleFilterValueChange(
                                        "PlannedRevenue",
                                        option.value
                                      )
                                    }
                                    style={{
                                      cursor: "pointer",
                                      padding: "5px 10px",
                                    }}
                                  >
                                    {option.label}
                                  </div>
                                );
                              }
                            })}
                          </div>
                        )}
                      </div>
                    </th>
                    <th
                      className="maxi-header"
                      style={{ position: "relative" }}
                    >
                      Current Revenue (₹)
                    </th>
                    {/* <th>
                      Planned EBITDA
                      <span
                        onClick={() => handleFilterChange("PlannedEBITDA")}
                        className={
                          appliedFilters.PlannedEBITDA ? "active-filter" : ""
                        }
                        ref={filterRefs[8]}
                        style={{ cursor: "pointer" }}
                      >
                       <FaFilter
                          style={{ marginLeft: "5px", cursor: "pointer", fontSize:"10px" }}
                        />
                      </span>
                      <span
                        onClick={() =>
                          handleSort(
                            "plannedEbitda",
                            sortDirectionPlannedEBITDA,
                            setSortDirectionPlannedEBITDA
                          )
                        }
                        style={{ cursor: "pointer" }}
                      >
                        {sortDirectionPlannedEBITDA === "ascending" && (
                          <FaAngleUp />
                        )}
                        {sortDirectionPlannedEBITDA === "descending" && (
                          <FaAngleDown />
                        )}
                        {sortDirectionPlannedEBITDA === "none" && (
                          <FaSort style={{ marginLeft: "5px" }} />
                        )}
                      </span>
                      <div ref={filterRefs[9]}>
                        {filterVisibility.PlannedEBITDA && (
                          <div className="filter-item">
                            {Array.from(
                              new Set(
                                projects.map((project) => project.plannedEbitda)
                              )
                            ).map((value, index) => (
                              <div
                                key={index}
                                onClick={() =>
                                  handleFilterValueChange(
                                    "PlannedEBITDA",
                                    value
                                  )
                                }
                                style={{
                                  cursor: "pointer",
                                  padding: "5px 10px",
                                  backgroundColor: plannedEbitdaFilter.includes(
                                    value
                                  )
                                    ? "lightblue"
                                    : "transparent",
                                }}
                              >
                                {value}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </th> */}
                    {/* <th>
                      Target EBITDA
                      <span
                        onClick={() => handleFilterChange("TargetEBITDA")}
                        className={
                          appliedFilters.TargetEBITDA ? "active-filter" : ""
                        }
                        style={{ cursor: "pointer" }}
                        ref={filterRefs[10]}
                      >
                       <FaFilter
                          style={{ marginLeft: "5px", cursor: "pointer", fontSize:"10px" }}
                        />
                      </span>
                      <span
                        onClick={() =>
                          handleSort(
                            "targetEbitda",
                            sortDirectionTargetEBITDA,
                            setSortDirectionTargetEBITDA
                          )
                        }
                        style={{ cursor: "pointer" }}
                      >
                        {sortDirectionTargetEBITDA === "ascending" && (
                          <FaAngleUp />
                        )}
                        {sortDirectionTargetEBITDA === "descending" && (
                          <FaAngleDown />
                        )}
                        {sortDirectionTargetEBITDA === "none" && (
                          <FaSort style={{ marginLeft: "5px" }} />
                        )}
                      </span>
                      <div ref={filterRefs[11]}>
                        {filterVisibility.TargetEBITDA && (
                          <div className="filter-item">
                            {Array.from(
                              new Set(
                                projects.map((project) => project.targetEbitda)
                              )
                            ).map((value, index) => (
                              <div
                                key={index}
                                onClick={() =>
                                  handleFilterValueChange("TargetEBITDA", value)
                                }
                                style={{
                                  cursor: "pointer",
                                  padding: "5px 10px",
                                  backgroundColor: targetEbitdaFilter.includes(
                                    value
                                  )
                                    ? "lightblue"
                                    : "transparent",
                                }}
                              >
                                {value}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </th> */}
                    {/* <th>
                      Actual EBITDA
                      <span
                        onClick={() => handleFilterChange("ActualEBITDA")}
                        className={`filter-icon ${
                          appliedFilters.ActualEBITDA ? "active-filter" : ""
                        }`}
                        style={{ cursor: "pointer" }}
                        ref={filterRefs[12]}
                      >
                       <FaFilter
                          style={{ marginLeft: "5px", cursor: "pointer", fontSize:"10px" }}
                        />
                      </span>
                      <span
                        onClick={() =>
                          handleSort(
                            "actualEbitda",
                            sortDirectionActualEBITDA,
                            setSortDirectionActualEBITDA
                          )
                        }
                        style={{ cursor: "pointer" }}
                      >
                        {sortDirectionActualEBITDA === "ascending" && (
                          <FaAngleUp />
                        )}
                        {sortDirectionActualEBITDA === "descending" && (
                          <FaAngleDown />
                        )}
                        {sortDirectionActualEBITDA === "none" && (
                          <FaSort style={{ marginLeft: "5px" }} />
                        )}
                      </span>
                      <div ref={filterRefs[13]}>
                        {filterVisibility.ActualEBITDA && (
                          <div className="filter-item">
                            {Array.from(
                              new Set(
                                projects.map((project) => project.actualEbitda)
                              )
                            ).map((value, index) => (
                              <div
                                key={index}
                                onClick={() =>
                                  handleFilterValueChange("ActualEBITDA", value)
                                }
                                style={{
                                  cursor: "pointer",
                                  padding: "5px 10px",
                                  backgroundColor: actualEbitdaFilter.includes(
                                    value
                                  )
                                    ? "lightblue"
                                    : "transparent",
                                }}
                              >
                                {value}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </th> */}
                   <th>Planned EBITDA %</th>
                    <th className="maxi">Target EBITDA (%)</th>
                    <Tooltip
                      componentsProps={{
                        tooltip: {
                          sx: tooltipStyles.tooltip,
                        },
                      }}
                      title={<ToolTipComponent />}
                    >
                      <th className="maxi">Actual EBITDA (%)</th>
                    </Tooltip>
                    {/* </Tooltip><th className="maxi" title={tooltipContent}>
    Actual EBITDA (%)
    
  </th> */}
                    <th className="maxi">Effort Delay (hrs)</th>
                    <th className="maxi">Extension (hrs)</th>
                    <th className="maxi">CR (hrs)</th>
                    {/* <th>Efforts Delay By Over Logging %</th> */}

                    {/**By Extension Tickets
                     */}
                    {/* <th>Efforts Delay By Extension Tickets%</th> */}
                    {/* <th>Expected Min Billing</th>
                    <th>Expected Max Billing</th> */}
                    <Tooltip
                      componentsProps={{
                        tooltip: {
                          sx: tooltipStyles.tooltip,
                        },
                      }}
                      title={<BillingStatus />}
                    >
                      <th>Underbilling/Overbilling Status (₹) </th>
                    </Tooltip>
                    <th>Revenue Absorbed (₹) </th>

                    <Tooltip
                      componentsProps={{
                        tooltip: {
                          sx: tooltipStyles.tooltip,
                        },
                      }}
                      title={<Satisfaction />}
                    >
                      <th>Team Satisfaction </th>
                    </Tooltip>
                    <Tooltip
                      componentsProps={{
                        tooltip: {
                          sx: tooltipStyles.tooltip,
                        },
                      }}
                      title={<Satisfaction />}
                    >
                      <th>Customer Satisfaction </th>
                    </Tooltip>
                    <th className="ellipsis" title="Technical Lead">
                      TL
                    </th>
                    <th className="ellipsis" title="Project Owner">
                      PO
                    </th>
                    <th className="ellipsis" title="Delivery Manager">
                      DM
                    </th>
                    <th className="ellipsis" title="Project Manager">
                      PM
                    </th>
                    <th>Edit</th>
                    <th>Delete</th>
                  </tr>
                </thead>
                <TableBodys
                  projects={filterProjects}
                  expandedProjectId={expandedProjectId}
                  handleProjectNameClick={handleProjectNameClick}
                  handleEditClick={handleEditClick}
                />
              </table>
            </div>
          </div>
          <div className="filter-controls">
            {watchActiveFilters ? (
              <button onClick={clearAllFilters}>Clear All Filters</button>
            ) : (
              <button className="disabled" onClick={clearAllFilters} disabled>
                Clear All Filters
              </button>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default InternalDashboardTable;
